import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { en } from "./locales/en";
import { ptBR } from "./locales/pt-BR";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      pt: { translation: ptBR },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "pt"],
    load: "languageOnly", // "pt-BR" / "en-US" -> "pt" / "en"
    interpolation: { escapeValue: false },
    detection: {
      order: ["querystring", "localStorage", "navigator"],
      lookupQuerystring: "lng",
      lookupLocalStorage: "avoria-lang",
      caches: ["localStorage"],
    },
    react: { useSuspense: false },
  });

// Keep <html lang> in sync (pt -> pt-BR for correct locale semantics).
const applyHtmlLang = (lng: string) => {
  document.documentElement.lang = lng.startsWith("pt") ? "pt-BR" : "en";
};
applyHtmlLang(i18n.resolvedLanguage || i18n.language || "en");
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
